import React, { Fragment } from 'react'
import { Dropdown } from 'stylist'
import normalizeHostname from 'utils/normalizeHostname'

const ServersDropdown = ({ servers, platform, setState }) => (
  <Fragment>
    {servers.length ? (
      <Dropdown
        name={platform.id}
        onChange={redirectTo => setState({ redirectTo, showInput: false })}
      >
        {servers.map(server => (
          <Dropdown.Option
            key={server.hostname}
            value={normalizeHostname(server.hostname, platform.id)}
          >
            {server.name || server.hostname}
          </Dropdown.Option>
        ))}
      </Dropdown>
    ) : (
      <Dropdown
        name={platform.id}
        onChange={redirectTo => setState({ redirectTo, showInput: false })}
      >
        {platform.homeUrls.map(({ name, url }) => (
          <Dropdown.Option key={url} value={url}>
            {name || url}
          </Dropdown.Option>
        ))}
      </Dropdown>
    )}
  </Fragment>
)

export default ServersDropdown



// WEBPACK FOOTER //
// ./src/routes/home/components/MultiServerPlatformNavLink/ServersDropdown.js